exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".play-icon{background:#fff;border-radius:50%;width:55px;height:55px;position:absolute;left:0;bottom:0;right:0;top:0;margin:auto;z-index:1}.play-icon__icon{position:absolute;left:0;bottom:0;right:0;top:0;margin:auto;color:#727e82}.play-icon>svg{width:24px}.play-icon-small{width:30px;height:30px}.play-icon-small>svg{width:18px}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};